import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TableCell, TableRow } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  tableRoot: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  tableContainer: {
    maxHeight: '70vh',
    borderRadius: 5,
  },
  customHeaderCont: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableHeaders: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: theme.spacing(1),
    minWidth: 150,
    fontWeight: '600',
    fontSize: '12px',
  },
  weekSelectorContent: {
    color: 'black',
  },
  container: {
    paddingBottom: theme.spacing(2),
    width: '80vw',
  },
  iconCell: {
    display: 'flex',
    justifyContent: 'space-around',
  },
  btn: {
    margin: theme.spacing(1),
    color: 'white',
    background: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  negativeBtn: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.secondary.dark,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  approveBtn: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
    maxHeight: 56,
    marginLeft: theme.spacing(1),
  },
  exportBtn: {
    marginLeft: theme.spacing(130),
    margin: theme.spacing(2),
    color: theme.palette.common.white,
    background: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  exportBtnUser: {
    display: 'flex',
    justifyContent: 'flexStart',
    color: theme.palette.common.white,
    background: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  menu: {
    width: 200,
  },
  dropdown: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  icons: {
    color: theme.palette.primary.main,
    '&:hover': {
      color: theme.palette.secondary.dark,
    },
  },
  disabledIcons: {
    color: theme.palette.secondary.light,
  },
  dialogTitleContainer: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.dark,
    borderBottom: 'solid',
  },
  dialogTitle: {
    fontWeight: 'bold',
  },
  popover: {
    pointerEvents: 'none',
  },
  popOverStyle: {
    padding: '20px',
    minHeight: '100px',
    minWidth: '300px',
    maxWidth: '700px',
  },
  chip: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    marginTop: 12,
    fontWeight: 'bold',
  },
  downloadIcon: {
    color: theme.palette.primary.dark,
    backgroundColor: 'white',
  },
  image: {
    width: '100%',
    border: 'solid',
    borderWidth: '30px',
    borderColor: theme.palette.secondary.dark,
    borderRadius: '10px',
  },
  tileBar: {
    borderBottomLeftRadius: '10px',
    borderBottomRightRadius: '10px',
  },
  arrowIcons: {
    color: theme.palette.primary.dark,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  sortLabel: {
    color: theme.palette.common.white,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  formRoot: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  noDataMessage: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  gridElLeft: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
    },
  },
  gridElRight: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
    },
  },
  btnMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
  btnMobile2: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
    [theme.breakpoints.up('sm')]: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
      },
      maxHeight: 56,
    },
  },
  inputMobile: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {},
  },
}));

export const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    borderBottom: 'none',
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
}))(TableRow);
